// extracted by mini-css-extract-plugin
export var container = "_2c-0";
export var error = "_2c-9";
export var label = "_2c-5";
export var light = "_2c-6";
export var md = "_2c-3";
export var sm = "_2c-2";
export var thin = "_2c-8";
export var thinBold = "_2c-7";
export var vertical = "_2c-4";
export var xs = "_2c-1";